__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "loja-digital-frontend";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@grupoboticario/flora-react-icons", "9.0.8", () => (Promise.all([__webpack_require__.e(8984), __webpack_require__.e(3855), __webpack_require__.e(3520), __webpack_require__.e(6693)]).then(() => (() => (__webpack_require__(28984))))));
			register("@grupoboticario/flora", "0.20.0", () => (Promise.all([__webpack_require__.e(179), __webpack_require__.e(3855)]).then(() => (() => (__webpack_require__(60179))))));
			register("antd", "4.18.9", () => (Promise.all([__webpack_require__.e(537), __webpack_require__.e(5678), __webpack_require__.e(1913), __webpack_require__.e(4231), __webpack_require__.e(4452), __webpack_require__.e(3855), __webpack_require__.e(6717), __webpack_require__.e(8326)]).then(() => (() => (__webpack_require__(84452))))));
			register("configcat-js", "6.0.1", () => (Promise.all([__webpack_require__.e(537), __webpack_require__.e(7353), __webpack_require__.e(5606)]).then(() => (() => (__webpack_require__(77353))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(537), __webpack_require__.e(1562), __webpack_require__.e(3855)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(537), __webpack_require__.e(1113), __webpack_require__.e(3855), __webpack_require__.e(6717), __webpack_require__.e(197)]).then(() => (() => (__webpack_require__(61113))))));
			register("react-router-dom", "6.22.3", () => (Promise.all([__webpack_require__.e(537), __webpack_require__.e(2648), __webpack_require__.e(3855), __webpack_require__.e(6717), __webpack_require__.e(3225)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "17.0.2", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "4.1.3", () => (Promise.all([__webpack_require__.e(537), __webpack_require__.e(9750), __webpack_require__.e(3855), __webpack_require__.e(6717), __webpack_require__.e(368)]).then(() => (() => (__webpack_require__(49750))))));
			initExternal(89018);
			initExternal(85394);
			initExternal(94366);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};